import React, {FC, useEffect, useState, MouseEvent, ChangeEvent}  from 'react';
import {useParams} from 'react-router';
import { useNavigate } from 'react-router-dom';

// import MUI.
import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, MenuItem, IconButton, Checkbox, FormControlLabel} from '@mui/material';
import {Menu as MenuIcon, AccountCircle as AccountCircleIcon, 
  Home as HomeIcon, ManageAccounts as ManageAccountsIcon, Logout as LogoutIcon } from '@mui/icons-material';

  import ToggleButton from '@mui/material/ToggleButton';
  import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';


  import { DatePicker } from '@mui/x-date-pickers';

// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import {useQuery,useQueryClient, QueryClient, QueryClientProvider, useMutation,useQueries, UseQueryResult } from "react-query";
import { useSnackbar } from 'notistack';
import { useTranslation  } from 'react-i18next';

// import user Component
import BasicSelectList from '../../ui/BasicSelectList';
import EnhancedTable, {EnhancedTableProps, HeadCell,EnhancedTableToolbarProps } from '../../ui/EnhancedTable';
import ArrayFieldTable from '../../ui/ArrayFieldTable';

// import user Library.
import { globalConfig } from "../../configuration/config";

import IBankRole from './model/BankRole';
import {IEnumerationItem} from '../configuration/model/Enumeration';

import useBankRoleService from './service/BankRole';
import useGroupPolicyService from './service/GroupPolicy';
import useBankPolicyService from './service/BankPolicy';
import useEnumerationService from '../configuration/service/Enumeration';

import {useUserStore} from '../../library/store'; 
import IGroupPolicy,{defaultGroupPolicy, IProductByGroupPolicy}  from './model/GroupPolicy';
import IBankPolicy from './model/BankPolicy';




type PolicyFilter = 'userC' | 'userU' | 'agency' | 'all';
type StatusFilter = '00095' | '00010';

const BankGroupPolicyForm: FC<IGroupPolicy> = (props : IGroupPolicy = defaultGroupPolicy) => {

  const { setCurrentEntity,currentUser, setCurrentObjectDataDef, setCurrentObjectKey } = useUserStore();
  const {language: lg} = currentUser;
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const {groupPolicyID} = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const [_groupPolicyID, _setGroupPolicyID] = useState<number>( Number( groupPolicyID || 0 ) );

  const methods = useForm<IGroupPolicy>();
  const { register, setValue ,getValues,watch, trigger, handleSubmit ,control , formState: { errors } } = methods;

 
  const {getRolesList} = useBankRoleService();
  const {getUserGroupPoliciesList, getUserAgenciesList, getGroupPolicyProductsList} = useGroupPolicyService();
  const {getEnumerationItemsList} = useEnumerationService();

  const {getBankPoliciesFilterList} = useBankPolicyService();

  const {isSuccess: isUserGroupPoliciesSuccess, status: userGroupPoliciesStatus,data: userGroupPolicies} = useQuery<IGroupPolicy[]>("userGroupPolicies",getUserGroupPoliciesList);

  const [ {isSuccess: isUserAgenciesSuccess, status: userAgenciesStatus,data : userAgencies },
    // {isSuccess: isPolicyStatusSuccess, status: policyStatusStatus,data: allPolicyStatus},
    // {isSuccess: isCivilitiesSuccess, status: civilitiesStatus,data: allCivilities},
    // {isSuccess: isFrequenciesSuccess, status: frequenciesStatus,data: allFrequencies},
    // {isSuccess: isSitMatSuccess, status: sitMatStatus,data: allSitMat},
    // {isSuccess: isLanguagesSuccess, status: languagesStatus,data: allLanguages},

  ] = useQueries([
    {queryKey: ['userAgencies'], queryFn: getUserAgenciesList},
    // {queryKey: ['policyStatus'], queryFn: () => getEnumerationItemsList('POLICY_STT')},
    // {queryKey: ['civilities'], queryFn: () => getEnumerationItemsList('CIVILITE')},
    // {queryKey: ['paymentFrequencies'], queryFn: () => getEnumerationItemsList('FRACTIONE')},
    // {queryKey: ['sitMats'], queryFn: () => getEnumerationItemsList('SIT_MATRIM')},
    // {queryKey: ['languages'], queryFn: () => getEnumerationItemsLanguageList()},
    ]) as UseQueryResult<IEnumerationItem[]>[];

  const [policiesSelected, setPoliciesSelected] = useState<number[]>([]);

  const {isSuccess: isGroupPolicyProductsSuccess, status: groupPolicyProductsStatus,data: groupPolicyProducts} = useQuery<IProductByGroupPolicy[]>("groupPolicyProducts", getGroupPolicyProductsList);
  const [currentProducts, setCurrentProducts] = useState<IProductByGroupPolicy[]>(groupPolicyProducts || []);


  const [filter, setFilter] = useState<PolicyFilter>('userC');
  const handleFilterChange = ( event: React.MouseEvent<HTMLElement>, newFilter: PolicyFilter, ) => {
    if(newFilter === null) return;
    setFilter(newFilter);
  };

  const [statusFilter, setStatusFilter] = useState<StatusFilter>('00095');
  const handleFilterPolicyStatus = ( event: React.MouseEvent<HTMLElement>, newStatusFilter: StatusFilter, ) => {
    if(newStatusFilter === null) return;
    setStatusFilter(newStatusFilter);
  };
  
  const {isSuccess: isBankPsSuccess, status: bankPersonsStatus,refetch: refetchBankPersons,data: bankPolicies} = 
      useQuery<IBankPolicy[]>(['BankPolicies', _groupPolicyID,statusFilter ,filter ], 
        () => getBankPoliciesFilterList( _groupPolicyID,statusFilter, filter ),
      {enabled: _groupPolicyID > 0 && (filter as string) !== '' && (statusFilter as string) !== ''} );
  //const {isSuccess: isAgenciesSuccess, status: agenciesStatus,data: allAgencies} = useQuery<IEnumerationItem[]>("agencies",getAgenciesList);
  //const {isSuccess: isServicesSuccess, status: servicesStatus,data: allServices} = useQuery<IEnumerationItem[]>("services", () => getEnumerationItemsList('SERVICE'));

  const [headProductCells, setHeadProductCells]  = useState<HeadCell<IProductByGroupPolicy>[]>([
    {id:'productCode', label : t('Code'),  display: true, type: 'string'},
    {id:'productName', label : t('Product'),  display: true, type: 'string'},      
  ]);

  const [headAgencyCells, setHeadAgencyCells]  = useState<HeadCell<IEnumerationItem>[]>([
    {id:'enumerationItemCode', label : t('Code'),  display: true, type: 'string'},
    {id:'enumerationItemName', label : t('Agency'),  display: true, type: 'string'},      
  ]);

  const [headBankPolicyCells, setHeadBankPolicyCells]  = useState<HeadCell<IBankPolicy>[]>([
    {id:'policyID', label : t('ID'),  display: true, type: 'string'},
    {id:'productName', label : t('Product'),  display: true, type: 'string'},    
    {id:'contractNumberManual', label : t('ManualNumber'),  display: true, type: 'string'}, 
    
    {id:'effectiveDate', label : t('EffectiveDate'),  display: true, type: 'date'}, 
    {id:'expirationDate', label : t('ExpirationDate'),  display: true, type: 'date'}, 
    {id:'firstName', label : t('First Name'),  display: true, type: 'string'}, 
    {id:'lastName', label : t('Last Name'),  display: true, type: 'string'}, 
    {id:'birthDate', label : t('Birth Date'),  display: true, type: 'date'}, 

    {id:'capital', label : t('Capital'),  display: true, type: 'numeric'},
    {id:'netPremium', label : t('Net_Premium'),  display: true, type: 'numeric'},
  ]);
  

  const watchGroupPolicy = watch("groupPolicyID");

  useEffect( () => {
    setCurrentEntity(t('BankGroupPolicy'));
    setCurrentObjectDataDef('00010'); //
    //setCurrentObjectKey( _groupPolicyID.toString());
    // setCurrentObjectKey(  _groupPolicyID<=0? '': globalConfig.get().backend === 'old' ?   _groupPolicyID.toString());
  }, [] );

  useEffect(() => {    
    const data = getValues();
    const groupPolicyID = data.groupPolicyID || 0;  
    
    console.log(data);

    const arr = (groupPolicyProducts || []).filter(x => x.groupPolicyID === groupPolicyID);
      setCurrentProducts([...arr]);

    if(userGroupPolicies && groupPolicyID > 0) {
      _setGroupPolicyID(groupPolicyID);

      
      
      const groupPolicy = userGroupPolicies.find(x => x.groupPolicyID === groupPolicyID) as IGroupPolicy;
      if(groupPolicy) {
        setValue('customerName', groupPolicy.customerName);
        setValue('lineOfBusinessName', groupPolicy.lineOfBusinessName);
        setValue('effectiveDate', groupPolicy.effectiveDate);
        setValue('issueDate', groupPolicy.issueDate);

        setCurrentObjectKey( globalConfig.get().backend === 'old' ? groupPolicy.contractNumber :  groupPolicy.groupPolicyID.toString());
      }
    }
  }, [watchGroupPolicy]);

  const handleRowPolicyDoubleClick = (event: React.MouseEvent<unknown>, row: IBankPolicy) => {
    const {policyID} = row;

    if( (policyID || 0) > 0)         
        navigate(`/bankPolicy/${policyID}`);
  }

  

  const saveData = async (event: MouseEvent<HTMLButtonElement>) => {

    const data = getValues();   
    console.log(data); 
    //mutate(data);
  }

  const listData = async (event: MouseEvent<HTMLButtonElement>) => {
    //navigate('bankRoleList');
    //setOpenRoleList(true);
  }

    return (
      <>
        <FormProvider {...methods} >
          <Grid container component="main" sx={{  width: '100%' }} alignItems="flex-start">
            <Grid item xs={12} sm={5} md={4} component={Paper} elevation={6} square>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                  <Controller name='groupPolicyID' control={control} defaultValue={0}
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(50% - 8px)'}} id="groupPolicyID" label={t('Contract')}>
                        {userGroupPolicies && userGroupPolicies.map( 
                          (ei,idx) => <MenuItem key={ei.groupPolicyID} value={ei.groupPolicyID}>{ei.groupContractName}</MenuItem> )
                        }
                        </TextField>
                      )}
                  />
                  <TextField  sx={{width:'calc(50% - 8px)'}} id="userID" label={t('LineOfBusiness')} {...register('lineOfBusinessName')}/>      
                                     
                  
                  <Button id='btnList__' onClick={listData} sx={ {display:'none'}}  />
                </Box>                       
                <Box sx={{ mt: 1, width: '100%' }} >                                       
                  <TextField  sx={{width:'calc(100% - 8px)'}} id="userID" label={t('Name')} {...register('customerName')}/>     
                </Box>  
                <Box sx={{ mt: 1, width: '100%' }} >  
                  <Controller control={control}  name='effectiveDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label={t('EffectiveDate')}  readOnly
                          onChange={onChange}                        
                          value={value}
                          renderInput={(params) => <TextField {...params} sx={{width:'calc(30% - 8px)'}} />}
                        /> )}
                  />      
                  <Controller control={control}  name='issueDate' 
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker label={t('IssueDate')}  readOnly
                          onChange={onChange}                        
                          value={value}
                          renderInput={(params) => <TextField {...params} sx={{width:'calc(30% - 8px)'}} />}
                        /> )}
                  />  
                </Box>       
              </Box>
              <Box sx={{ mt: 1, width: '100%' }} >
                <EnhancedTable<IProductByGroupPolicy> headCells={headProductCells} rows={currentProducts} order='asc' orderBy='productCode'
                    title={t('Products')} objKey='productCode'  //onRowSelected={handleRoleItemSelected}
                    toolbarActions={[]} />
              </Box>
              <Box sx={{ mt: 1, width: '100%' }} >  
                <EnhancedTable<IEnumerationItem> headCells={headAgencyCells} rows={userAgencies || []} order='asc' orderBy='enumerationItemCode'
                    title={t('Agencies')} objKey='enumerationItemCode' //onRowSelected={handleRoleItemSelected}
                    toolbarActions={[]} />
              </Box> 
            </Grid>        
            <Grid item xs={12} sm={7} md={8} component={Paper} elevation={6} square>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                <Box sx={{ mt: 1, width: '100%' }} >
                  <ToggleButtonGroup value={statusFilter} exclusive size="small" onChange={handleFilterPolicyStatus} aria-label="text alignment" fullWidth >
                    <ToggleButton value="00095" aria-label="left aligned">
                      {t('Not validated')}
                    </ToggleButton>
                    <ToggleButton value="00010" aria-label="centered">
                      {t('Validated')}
                    </ToggleButton>                    
                  </ToggleButtonGroup>
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >
                <ToggleButtonGroup value={filter} exclusive size="small" onChange={handleFilterChange} aria-label="text alignment" fullWidth >
                  <ToggleButton value="userC" aria-label="left aligned">
                    {t('Created by me')}
                  </ToggleButton>
                  <ToggleButton value="userU" aria-label="centered">
                    {t('Updated by me')}
                  </ToggleButton>
                  <ToggleButton value="agency" aria-label="right aligned">
                    {t('Agency')}
                  </ToggleButton>
                  <ToggleButton value="all" aria-label="justified">
                    {t('All')}
                  </ToggleButton>
                </ToggleButtonGroup>
                </Box>
                <Box sx={{ mt: 1, width: '100%' }} >
                  <EnhancedTable<IBankPolicy> headCells={headBankPolicyCells} rows={bankPolicies || []} order='asc' orderBy='policyID'
                      title={t('Propositions')} objKey='policyID' //onRowSelected={handleRoleItemSelected}
                      stateSelected={[policiesSelected, setPoliciesSelected]} onRowDoubleClick={handleRowPolicyDoubleClick}
                      toolbarActions={[]} />
              </Box>
              </Box>
            </Grid>
          </Grid>
          
        </FormProvider>
      </>
    );
  }
  
  export default BankGroupPolicyForm;